import React from 'react'
import LoginComponent from '../../components/Login/LoginComponent'

const Login = () => {
    return (
        <div>
            <LoginComponent />
        </div>
    );
}

export default Login;
